import { Observable } from 'rxjs'
import { Facet } from '@spartacus/core'

export abstract class MbHomepageFacetsAdapter {

  abstract load(): Observable<Facet[]>
}
